import React, {FunctionComponent, useContext} from 'react';
import "./Overdue.scss"
import {InvoiceContext} from "../../context/InvoiceContext";
import rejectIcon from "../../assets/icons/ban-duotone.svg";
import {Button} from "../../components/ui-components/Button/Button";
import {CompanyContext} from "../../context/CompanyContext";

export const OverduePage: FunctionComponent = () => {
    const invoice = useContext(InvoiceContext);
    const company = useContext(CompanyContext);

    return (
        <div className='full-page-section'>
            <img src={rejectIcon} alt="reject" className="full-page-icon"/>
            <h1>{invoice.invoice_title} has expired and is no longer
                viewable. {company.is_email_visible && <>Please contact us for
                    assistance or to request a new {invoice.invoice_name}.</>}</h1>

            {company.is_email_visible && <div>
                <a className='overdue-payment-button' href={'mailto:' + company.email}><Button className="payment-button green-button">Contact</Button></a>
            </div>}
        </div>
    );
};